import type { JSX } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useActiveOrganization } from '@/features/organization/active-organization-context';

/**
 * Compact app-shell organization switcher (ADR-026 Addendum, AO-7/AO-8).
 * Renders nothing for a single-org account - there is nothing to switch
 * between and no reason to show a distracting control. Switching
 * invalidates every tenant-scoped query (inside `select`) and returns to
 * the organization-agnostic Dashboard route so no Org A resource can
 * remain on screen once Org B is active.
 */
export function OrganizationSwitcher(): JSX.Element | null {
  const { memberships, activeOrganizationId, select } = useActiveOrganization();
  const navigate = useNavigate();

  if (memberships.length <= 1 || activeOrganizationId === null) {
    return null;
  }

  return (
    <Select
      value={activeOrganizationId}
      onValueChange={(organizationId) => {
        select(organizationId);
        void navigate('/');
      }}
    >
      <SelectTrigger aria-label="Ganti organisasi" className="w-full">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {memberships.map((membership) => (
          <SelectItem key={membership.organizationId} value={membership.organizationId}>
            {membership.roleName}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
